import { DS_setData } from '../DS/DS.Data'
import { Rout_procedureContentPageRoutePattern } from './Rout.procedure'
import type { Rout_ChangeHook } from './Rout.ReactRouter'
import { Rout_unitContentPageRoutePattern } from './Rout.unit'

/**
 * `Rout.onChange` is run on every url transition as it's the onEnter
 * on the root '/' route in the router below
 */
export const Rout_onChange: Rout_ChangeHook<any, any, any> = (_, { location, routes }) => {
    /**
     * If you go directly back from the post page it should scroll to the post,
     * but if you go via any other page it should forget about it
     */
    const keepPostToScrollTo = routes.some(
        (route) =>
            route.path === Rout_procedureContentPageRoutePattern || route.path === Rout_unitContentPageRoutePattern
    )

    DS_setData('UrlChanged', ({ postToScrollTo }) => ({
        pathname: location.pathname,
        postToScrollTo: keepPostToScrollTo ? postToScrollTo : null,
    }))
}
